export default class Formatter {

    // number(1002.8) => 1 002.80
    public static number(number: number, precision: number = 2): string {
        return number
            .toFixed(precision)
            .toString()
            .replace(/\./g, ',')
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    }

    // number('11111') => '111 11'
    public static psc(input: string): string {
        return input.slice(0, 3) + ' ' + input.slice(3, 5);
    }

    // dateToString(new Date()) => "1. 1. 2020"
    public static dateToString(date: Date): string {
        return `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()}`;
    }

    public static dateToDateString(date: Date): string {
        return `${date.getFullYear()}-${this.fillChars((date.getMonth() + 1).toString(), '0', 2)}-${this.fillChars(date.getDate().toString(), '0', 2)}`;
    }

    public static dateToTimeString(date: Date): string {
        return `${this.fillChars(date.getHours().toString(), '0', 2)}:${this.fillChars(date.getMinutes().toString(), '0', 2)}`;
    }

    // dateTimeToString(new Date()) => "1. 1. 2020 20:00"
    public static dateTimeToString(date: Date): string {
        return `${this.dateToString(date)} ${this.dateToTimeString(date)}`;
    }

    // fillChars("1", "0", 3) => "001"
    public static fillChars(input: string, c: string, count: number): string {
        return (new Array(count).fill(c).join('') + input).slice(-count);
    }

    // YYYYMMDDtoDate("2020-01-01") => Date(2020, 1, 1)
    public static YYYYMMDDtoDate(str: string): Date {
        if (!str) return new Date();
        const d = str.split('T');
        const tmp = d[0].split('-').map(item => Number(item));
        return new Date(tmp[0], tmp[1] - 1, tmp[2]);
    }

    // Date(2020, 1, 1) => YYYYMMDDtoDate("2020-01-01")
    public static DateToYYYYMMDD(date: Date): string | undefined {
        if (!date) return;

        return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + (date.getDate())).slice(-2)}T00:00:00`;
    }

    public static DateToYYYYMMDDShort(date: Date): string {
        if (!date) return '';
        return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + (date.getDate())).slice(-2)}`;
    }

    // reshuffleDate("2020-1-1") => "1. 1. 2020"
    public static reshuffleDate(date: string): string {
        if (!date) return '';
        let newDat = String(date).split('T')[0].split('-');
        return `${Number(newDat[2])}. ${Number(newDat[1])}. ${newDat[0]}`;
    }

    // reshuffleDateTime("2020-1-1T11:21") => "1. 1. 2020, 11:21"
    public static reshuffleDateTime(date: string): string {
        if (!date) return '';
        const dat = Formatter.reshuffleDate(date);
        const cas = date.indexOf('T') > 0 ? String(date).split('T')[1].substring(0, 5) : '';
        return dat + ', ' + cas;
    }

    // reshuffleDateTime("2020-1-1T11:21") => "1.1.2020 11:21:34"
    public static reshuffleDateTimeSec(date: string): string {
        if (!date) return '';
        const dat = Formatter.reshuffleDate(date).replaceAll(' ', '');
        const cas = date.indexOf('T') > 0 ? String(date).split('T')[1].substring(0, 8) : '';
        return dat + ' ' + cas;
    }

    //repareNumberInput(NaN, '1,1) => 1.1
    public static repareNumberInput(originalValue: string) {
        return originalValue ? Number(originalValue.replace(/,/, '.')) : '';
    }

    //dateToMonth(new Date("2020-01-01")) => "LEDEN"
    public static dateToMonth(date: Date) {
        switch (date.getMonth()) {
            case 0: return 'LEDEN';
            case 1: return 'UNOR';
            case 2: return 'BREZEN';
            case 3: return 'DUBEN';
            case 4: return 'KVETEN';
            case 5: return 'CERVEN';
            case 6: return 'CERVENEC';
            case 7: return 'SRPEN';
            case 8: return 'ZARI';
            case 9: return 'RIJEN';
            case 10: return 'LISTOPAD';
            default: return 'PROSINEC';
        }
    }   

}
